import React from 'react';
import PropTypes from 'prop-types';

function signUp() {
  window.location = '/sign_up';
}
/*
Props:
- string contributorName: optional, if included then includes the contributor name in the CTA
*/
export default class SignUpInfoNagbar extends React.Component {
  static propTypes = {
    contributorName: PropTypes.string,
  };

  static defaultProps = {
    contributorName: null,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      showInfo: true,
      scrollWindowTop: 0,
      scrollWindowBottom: 0,
    };
  }

  componentDidMount() {
    const existingOnScroll = window.onscroll || (() => {});
    let onScrollTimer;
    window.onscroll = () => {
      existingOnScroll();
      clearTimeout(onScrollTimer);
      onScrollTimer = setTimeout(() => {
        this.onWindowScroll();
      }, 250);
    };
  }

  onWindowScroll() {
    // NOTE present the info CTA if scroll down past 25px threshold,
    // dismiss if scroll up
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    if (scrollTop < this.state.scrollWindowTop) {
      this.setShowInfoState(false);
    }

    if (scrollTop > this.state.scrollWindowBottom) {
      this.setShowInfoState(true);
    }

    if (scrollTop < this.state.scrollWindowTop || scrollTop > this.state.scrollWindowBottom) {
      this.setState(state => {
        state.scrollWindowTop = scrollTop - 25;
        state.scrollWindowBottom = scrollTop + 25;

        return state;
      });
    }
  }

  setShowInfoState(showInfo) {
    if (this.state.showInfo === showInfo) return;

    this.setState({ showInfo });
  }

  render() {
    return (
      <div className={`sign-up-info-nagbar ${this.state.showInfo ? '' : 'sign-up-info-closed'} hide-fully--mobile`}>
        <div className="sign-up-info-ui">
          <p>
            <span>Get investment ideas&nbsp;</span>
            {this.props.contributorName && (
              <span>
                from&nbsp;
                <strong>{this.props.contributorName}</strong>
                &nbsp;
              </span>
            )}
            <span>when you sign up to Livewire Markets.</span>
          </p>
          <button type="button" className="btn btn-primary" onClick={signUp}>
            GET&nbsp;INSIGHTS
          </button>
        </div>
      </div>
    );
  }
}
